import * as Yup from 'yup';
import { useState, forwardRef } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import {
  Stack,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContentText,
  DialogContent,
  Button,
  Slide
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ForgetPasswordRequest } from '../../../network/User';
import { parseValidationErrorMessage } from '../../../utils/Utilities';
import { SnackBarAlert } from '../../HelperComponents';

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ForgetPassowrdFormComp() {
  const [errorData, setErrorData] = useState({
    visible: false,
    message: '',
    title: ''
  });

  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const LoginSchema = Yup.object().shape({
    email: Yup.string().required('Email is required')
  });

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      requestForPasswordReset(formik.values.email, formik.values.password);
    }
  });

  const handleAlertDialogClose = () => {
    setErrorData({ ...errorData, visible: false, message: '' });
  };

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  function requestForPasswordReset(email, password) {
    ForgetPasswordRequest(email)
      .then((res) => {
        formik.setSubmitting(false);
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: 'Reset password link has been sent successfully !',
          severity: 'success'
        }));
        setIsSnackBarAlertOpen(true);
      })
      .catch((err) => {
        formik.setSubmitting(false);
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: parseValidationErrorMessage(err),
          severity: 'success'
        }));
        setIsSnackBarAlertOpen(true);
      });
  }

  return (
    <div>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              type="email"
              autoComplete="username"
              label="Email address"
              {...getFieldProps('email')}
              error={Boolean(touched.email && errors.email)}
              helperText={touched.email && errors.email}
            />
          </Stack>

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            sx={{ mt: 3 }}
          >
            SUBMIT
          </LoadingButton>
        </Form>
      </FormikProvider>

      <Dialog
        open={errorData?.visible}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleAlertDialogClose()}
        aria-describedby="iot_res_alert-dialog-slide-description"
      >
        <DialogTitle>{errorData?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="aiot_res_alert-dialog-slide-description">
            {errorData?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleAlertDialogClose()}>OK</Button>
        </DialogActions>
      </Dialog>

      <SnackBarAlert
        open={isSnackBarAlertOpen}
        title={snackBarMetas?.title}
        message={snackBarMetas?.message}
        severity={snackBarMetas?.severity}
        handleClose={() => setIsSnackBarAlertOpen(false)}
      />
    </div>
  );
}
